<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13yWFT2/tc-custom/9781504083522.jpg?1705348425985" alt="This image is the cover for the book Dorothy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dorothy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed nineteenth-century American author draws on her experiences living in Venice in this short story collection.</b></p> Constance Fenimore Woolson’s reputation as a great American novelist has only increased as new generations have discovered her works. Known for fiction that evokes the Great Lakes region of her youth, Woolson later traveled to Europe and eventually settled in Venice. This period resulted in a series of travel sketches as well as two posthumously published story collections. Along with the title story, this collection includes “A Transplanted Boy,” “A Florentine Experiment,” “A Waitress,” and “At the Chateau of Corinne.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance Fenimore Woolson
      </h2>
      
      <p class="authorDescription body article">Constance Fenimore Woolson (1840&ndash;1894) was educated at the Cleveland Female Seminary, and later became an American novelist, poet, and short story writer. She is best known for her fiction about the Great Lakes region, the American South, and American expatriates in Europe. In 1893, Woolson rented an elegant apartment in the Palazzo Orio Semitecolo Benzon on the Grand Canal of Venice. Suffering from influenza and depression, she either jumped or fell to her death from a fourth story window in the apartment in January 1894. She is buried in the Protestant Cemetery in Rome.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fda3f8b4